import { useEffect } from "react";
import Script from "next/script";
import { useRouter } from "next/router";

const NEXT_PUBLIC_GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_TRACKING_KEY;
const EXCLUDE_PATHS = ["*", "/**/*", "/", "/identify"];
const RESPECT_DNT = true;

// Function to log the page view
const logPageView = (url) => {
	if (RESPECT_DNT && navigator.doNotTrack === "1") {
		return;
	}
	if (!EXCLUDE_PATHS.includes(url)) {
		window.gtag("config", NEXT_PUBLIC_GA_TRACKING_ID, {
			page_path: url,
			anonymize_ip: true,
			allowLinker: true,
			sampleRate: 5,
			siteSpeedSampleRate: 10,
			cookie_domain: "felixmobile.com.au",
		});
	}
};

const GoogleAnalytics = () => {
	// Only use useRouter if in the browser
	const router = typeof window !== "undefined" ? useRouter() : null;

	useEffect(() => {
		if (!router) return; // Stop if useRouter is unavailable

		const handleRouteChange = (url) => {
			logPageView(url);
		};
		router.events.on("routeChangeComplete", handleRouteChange);
		return () => {
			router.events.off("routeChangeComplete", handleRouteChange);
		};
	}, [router]);

	return (
		<>
			<Script
				strategy="beforeInteractive"
				src={`https://www.googletagmanager.com/gtag/js?id=${NEXT_PUBLIC_GA_TRACKING_ID}`}
			/>
			<Script
				id="google-analytics"
				strategy="beforeInteractive"
				dangerouslySetInnerHTML={{
					__html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${NEXT_PUBLIC_GA_TRACKING_ID}', {
              anonymize_ip: true,
              page_path: window.location.pathname,
              page_location: window.location.href,
              allowLinker: true,   
            });
          `,
				}}
			/>
		</>
	);
};

export default GoogleAnalytics;
